import React from "react";
import ToDoApi from "../API/ToDoApi";
import {
    TaskRow as Row, TaskPhoto, TaskInfo, Comment, Info,
    PhotoList, SmallPhoto, StatusButton, Button
} from "./design";

const formatDate = (date) => {
    if (!date) return "";
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(date));
    return m ? `${m[3]}.${m[2]}.${m[1]}` : String(date);
};

const TaskRow = ({ task, busy, onPreview, onStatusChange, onDelete }) => {
    const photos = task.photos ?? [];
    const afterPhotos = task.completionPhotos ?? [];
    const firstPhoto = photos[0];

    return (
        <Row>
            {firstPhoto ? (
                <TaskPhoto
                    src={ToDoApi.getPhotoUrl(firstPhoto)}
                    alt="Vorher"
                    onClick={() => onPreview(ToDoApi.getPhotoUrl(firstPhoto))}
                />
            ) : (
                <div style={{ width: 85, height: 85, flexShrink: 0, background: "#f1f5f9", borderRadius: 8 }} />
            )}
            <TaskInfo>
                <Comment>{task.comment}</Comment>
                <Info>Von: {task.author}</Info>
                <Info>{formatDate(task.date)} · {task.house}</Info>
                {task.completedAt && <Info>Erledigt am: {formatDate(task.completedAt)}</Info>}
                <PhotoList>
                    {photos.map(photo => (
                        <SmallPhoto
                            key={photo.id}
                            src={ToDoApi.getPhotoUrl(photo)}
                            alt="Vorher"
                            title="Vorher"
                            onClick={() => onPreview(ToDoApi.getPhotoUrl(photo))}
                        />
                    ))}
                    {afterPhotos.map(photo => (
                        <SmallPhoto
                            key={photo.id}
                            src={ToDoApi.getPhotoUrl(photo)}
                            alt="Nachher"
                            title="Nachher"
                            style={{ border: "2px solid #019A32" }}
                            onClick={() => onPreview(ToDoApi.getPhotoUrl(photo))}
                        />
                    ))}
                </PhotoList>
            </TaskInfo>
            <StatusButton
                type="button"
                $done={task.completed}
                disabled={busy}
                onClick={() => onStatusChange(task)}
            >
                {task.completed ? "✓ Erledigt" : "○ Offen"}
            </StatusButton>
            <Button type="button" $secondary disabled={busy} onClick={() => onDelete(task)} title="Aufgabe löschen">
                ×
            </Button>
        </Row>
    );
};
export default TaskRow;
